module.exports = __webpack_public_path__ + "static/beijingtu_1.4bdebcb9.png";